import isEmpty from 'lodash/isEmpty'
import type { UseListResult } from '@ztechapps/common.hook'
import { useList } from '@ztechapps/common.hook'
import type { ShippingRate } from '@ztechapps/common.contract'
import { logisticGetShippingRatesQuery } from './graphql'

export type UseLogisticShippingRatesResult = UseListResult<ShippingRate>

// logisticGetShippingRates is a @Query, not a list on its own collection, so this wraps `useList`
// with an explicit query override rather than the `all{Entity}` shape — the same way the order
// module's useOrderShippingRates does (libs/order/webui/src/checkout/hooks/useOrderShippingRates.ts).
export const useLogisticShippingRates = ({
  logisticId,
}: { logisticId?: string } = {}): UseLogisticShippingRatesResult =>
  useList<ShippingRate>({
    query: logisticGetShippingRatesQuery,
    filter: { logisticId },
    limit: 0,
    options: {
      // network-only keeps loading=true until the live rates actually land, instead of a
      // premature ready state reading the still-empty cache.
      queryOptions: { skip: isEmpty(logisticId), fetchPolicy: 'network-only', nextFetchPolicy: 'network-only' },
    },
  })
